//
// see https://medium.com/@heyoka/scratch-made-svg-donut-pie-charts-in-html5-2c587e935d72
// and https://codepen.io/janverstr/pen/PvPoaV

import { ChartValue } from "./ChartValue";

//
export class DonutChart {

    public create(values: ChartValue[]): SVGSVGElement {
        let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        //svg.setAttribute("width", "100vw");
        //svg.setAttribute("height", "100vh");
        svg.setAttribute("viewBox", "0 0 42 42");
        svg.classList.add("a-svg");
        svg.classList.add("a-svg-donut");

        if (values && values.length > 0) {
            let total = 0;
            for (let value of values) {
                total += value.value;
            }
            if (total > 0) {
                let factor = 100 / total;
                let offset = 25;
                for (let value of values) {
                    let percent = value.value * factor;
                    if (percent > 0) {
                        svg.appendChild(this.createSegment(value.className, `${percent} ${100 - percent}`, offset.toString()));
                        offset = 100 - percent + offset;
                    }
                }
            }
        }
        return svg;

    }
    createSegment(className: string, dasharray: string, dashoffset: string): any {
        let segment = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        segment.classList.add(className);
        segment.setAttribute("cx", "21");
        segment.setAttribute("cy", "21");
        segment.setAttribute("r", "15.91549430918954");
        segment.setAttribute("fill", "transparent");
        segment.setAttribute("stroke-width", "8");
        segment.setAttribute("stroke-dasharray", dasharray);
        segment.setAttribute("stroke-dashoffset", dashoffset);
        return segment;
    }
}